module.exports = __webpack_public_path__ + "meeting-no-background.png?c856b3b1128a4e834b0640123cd3c5d5";